import {
  MdDashboard,
  MdStore,
  MdPeople,
  MdManageAccounts,
  MdCardMembership,
  MdSubscriptions,
  MdFitnessCenter,
  MdSupportAgent,
  MdEventAvailable,
  MdAccountBalance,
  MdViewModule,
  MdAssessment,
  MdDescription,
  MdPayment,
  MdPayments,
  MdNotifications,
  MdSettings,
  MdConfirmationNumber,
  MdAcUnit,
  MdEvent,
  MdBuild,
  MdSummarize,
  MdPointOfSale,
} from 'react-icons/md';
import { salePagesForBase } from '../pages/receptionist/sales/salePageConfig';

const saleItems = salePagesForBase('/admin').map(({ path, label, icon }) => ({ path, label, icon }));

export const adminNavItems = [
  { path: '/admin/dashboard', label: 'Dashboard', icon: MdDashboard, end: true },
  {
    id: 'members',
    label: 'Members',
    icon: MdPeople,
    children: [
      { path: '/admin/members', label: 'Members', icon: MdPeople },
      { path: '/admin/user-management', label: 'User Management', icon: MdManageAccounts },
      { path: '/admin/trainers', label: 'Trainers', icon: MdFitnessCenter },
      { path: '/admin/receptionists', label: 'Receptionists', icon: MdSupportAgent },
    ],
  },
  {
    id: 'memberships',
    label: 'Memberships',
    icon: MdSubscriptions,
    children: [
      { path: '/admin/packages', label: 'Packages', icon: MdCardMembership },
      { path: '/admin/memberships', label: 'Memberships', icon: MdSubscriptions },
      { path: '/admin/subscriptions', label: 'Subscriptions', icon: MdSubscriptions },
      { path: '/admin/guest-pass', label: 'Guest Pass', icon: MdConfirmationNumber },
      { path: '/admin/freeze', label: 'Freeze', icon: MdAcUnit },
    ],
  },
  {
    id: 'sales',
    label: 'Sales',
    icon: MdPointOfSale,
    children: [
      ...saleItems,
      { path: '/admin/remaining-payments', label: 'Remaining Payments', icon: MdPayments },
      { path: '/admin/remaining-payments-report', label: 'Remaining Payments Report', icon: MdAssessment },
    ],
  },
  {
    id: 'operations',
    label: 'Operations',
    icon: MdEventAvailable,
    children: [
      { path: '/admin/branches', label: 'Branches', icon: MdStore },
      { path: '/admin/attendance', label: 'Attendance', icon: MdEventAvailable },
      { path: '/admin/classes', label: 'Classes', icon: MdEvent },
      { path: '/admin/equipments', label: 'Equipments', icon: MdBuild },
    ],
  },
  {
    id: 'finance',
    label: 'Finance',
    icon: MdAccountBalance,
    children: [
      { path: '/admin/finance', label: 'Finance', icon: MdAccountBalance },
      { path: '/admin/payments', label: 'Payments', icon: MdPayments },
      { path: '/admin/all-module', label: 'Customer Ledger', icon: MdViewModule },
      { path: '/admin/payment-methods', label: 'Payment Gateway', icon: MdPayment },
    ],
  },
  {
    id: 'reports',
    label: 'Reports',
    icon: MdAssessment,
    children: [
      { path: '/admin/reports', label: 'Reports', icon: MdAssessment },
      { path: '/admin/detailed-report', label: 'Detailed Report', icon: MdDescription },
      { path: '/admin/petty-cash', label: 'Petty Cash', icon: MdPayments },
      { path: '/admin/bank', label: 'Bank', icon: MdAccountBalance },
      { path: '/admin/z-report', label: 'Z Report', icon: MdSummarize },
      { path: '/admin/z-report-1', label: 'Z Report 1', icon: MdSummarize },
    ],
  },
  { path: '/admin/notifications', label: 'Notifications', icon: MdNotifications },
  { path: '/admin/settings', label: 'Settings', icon: MdSettings },
];
